module.exports = __webpack_public_path__ + "static/media/reward-c.dee65b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/reward-c.png
// module id = 1873
// module chunks = 0